// extracted by mini-css-extract-plugin
export default {"saveTAModal":"saveTAModel_saveTAModal__8O6dL","error":"saveTAModel_error__uviO6","errorMessage":"saveTAModel_errorMessage__8+wSx"};